import React, { useState, useEffect, useRef } from "react";
import {useSelector, useDispatch} from 'react-redux';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { green } from "@material-ui/core/colors";
import {
  Grid,
  Button,
  Chip,
  TextField, 
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@material-ui/core/";
import UpdateStockButton from "views/Widgets/UpdateStockButton";
import SelectExam from "../SelectExam";
import api from "utils/API";
import {
  getListSuppliesMedicines,
} from "actions/getListAction";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import MedicalTableComponent from "../../InsumosYMedicamentos/MedicalTableComponent";
import ResourceTableComponent from "../../InsumosYMedicamentos/ResourceTableComponent";
import DialogSendRequest from "../DialogSendRequest";
import apiform from "utils/APIForm";
import moment from "moment-timezone";
import {
  getListRequestPatient,
} from 'actions/getListAction';
import "moment/locale/es";
moment.locale("es");


const useStyles = makeStyles({
  microText: {
    fontSize: 10,
    color: '#BDBDBD'
  },
  answerIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginRight: '1rem',
  },
  disabledColor: {
    color: '#BDBDBD'
  },

  '@media (max-width: 800px)': {
  },
});


const ModalRequestExam = props => {
  const dispatch = useDispatch()
  const {
    openModal,
    closeModal,
    examSelected,
    selectedListExam,
    handleExamSelected,
    handleExamDeleted,
    examsList,
    tempExam,
    setTypeRequest,
    indications,
    setIndications,
    justifications,
    setJustifications,
    responsable,
    setResponsable,
    dataPatient,
    dataMedicalArray,
    setDataMedicalArray,
    dataResourceArray,
    setDataResourceArray,
    clinic,
  } = props;
  const classes = useStyles();
  const [pageRefresh, setPageRefresh] = useState(false);


  const [openDialogSendRequest, setOpenDialogSendRequest] = useState(false);
  const [fileRequestExam, setFilesRequestExam] = useState(null);
  const [fileIsapreAuthorization, setFileIsapreAuthorization] = useState(null);
  const [fileFichaClinica, setFileFichaClinica] = useState(null);
  const [fileCotizacionExterna, setFileCotizacionExterna] = useState(null);
  const [requiereFormularioIsapre, setRequiereFormularioIsapre] = useState(false);
  const [fileFormularioIsapre, setFileFormularioIsapre] = useState(null);
  const [examDate, setExamDate] = useState(moment());
  const [priority, setPriority] = useState("Media");
  const [responseFile, setresponseFile] = useState(null);
  const [sending, setsending] = useState(false);
  const uploadedDocsRef = useRef({ order: null, isapre: null, fichaClinica: null, cotizacion: null, formularioIsapre: null });

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => (
    <Button style={{background: "#af4c4c00", color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
        CERRAR
    </Button>
  );

  const handleSnakeMessage = (message, variant, vertical= "top", hotizontal="center", persist=false) => {
    enqueueSnackbar(
        message,
        {
            variant,
            persist: persist,
            action,
            preventDuplicate: true,
            anchorOrigin: {
                vertical: vertical,
                horizontal: hotizontal,
            },
        }
    );
  };

  useEffect(() => {
    if (pageRefresh) {
      setPageRefresh(false);
    }
  });

  const listMedical = useSelector(state => state.currentList.listMedicines);
  const listResource = useSelector(state => state.currentList.listSupplies);
  const medicalResourceData = useSelector(state => state.currentList.dictSuppliesMedicines);
  const chargeMedicine = useSelector(state => state.currentGlobalVar.chargeMedicine);

  useEffect(() => {
    if(listMedical.length === 0) {
        getListSuppliesMedicines(dispatch, chargeMedicine)
    }
  }, [])

  useEffect(() => {
    api.get(`api/paciente/${dataPatient.id}/solicitudes/extras/requisitosdocumentos/`).then((response) => {
      setRequiereFormularioIsapre(response.data.requiere_formulario_isapre);
    }).catch(() => {});
  }, [])

  useEffect(() => {
    if(responseFile !== null) {
      sendExam()
    }
  }, [responseFile])

  useEffect(() => {
    if (pageRefresh) {
      setPageRefresh(false);
    }
  });

  const updateStock = () => {

    api.get("/api/poblarinsumos/").then(() => {
      getListSuppliesMedicines(dispatch, chargeMedicine, true);

    });
  };

  
  const handleResponsable = () => {
    setResponsable(!responsable);
  };

  const handlePriority = (event) => {
    setPriority(event.target.value);
  };

  const handleExamDate = (date) => {
    setExamDate(date);
  };

  const uploadDocument = () => {
    if (sending) {
      return;
    }
    setsending(true);
    const requestDocument = []
    const cache = uploadedDocsRef.current;
    if (fileRequestExam != null) {
      if (cache.order && cache.order.file === fileRequestExam[0]) {
        requestDocument.push(Promise.resolve({ data: cache.order.data }))
      } else {
        const formData = new FormData();
        formData.append("archivo", fileRequestExam[0]);
        formData.append("tipo_documento", "OrdenExamenes");
        formData.append("nombre_archivo", fileRequestExam[0].name);
        formData.append("id_paciente", dataPatient.id);
        const requestOrder = apiform.post(`/api/documentospaciente/`,formData).then((response) => {
          cache.order = { file: fileRequestExam[0], data: response.data };
          return response;
        })
        requestDocument.push(requestOrder)
      }

    }
    if (fileIsapreAuthorization !== null) {
      if (cache.isapre && cache.isapre.file === fileIsapreAuthorization[0]) {
        requestDocument.push(Promise.resolve({ data: cache.isapre.data }))
      } else {
        const formData2 = new FormData();
        formData2.append("archivo", fileIsapreAuthorization[0]);
        formData2.append("tipo_documento", "AutorizacionExamenesIsapre");
        formData2.append("nombre_archivo", fileIsapreAuthorization[0].name);
        formData2.append("id_paciente", dataPatient.id);

        const requestIsapre = apiform.post(`/api/documentospaciente/`,formData2).then((response) => {
          cache.isapre = { file: fileIsapreAuthorization[0], data: response.data };
          return response;
        })
        requestDocument.push(requestIsapre)
      }
    }
    if (fileFichaClinica != null) {
      if (cache.fichaClinica && cache.fichaClinica.file === fileFichaClinica[0]) {
        requestDocument.push(Promise.resolve({ data: cache.fichaClinica.data }))
      } else {
        const formData3 = new FormData();
        formData3.append("archivo", fileFichaClinica[0]);
        formData3.append("tipo_documento", "FichaClinica");
        formData3.append("nombre_archivo", fileFichaClinica[0].name);
        formData3.append("id_paciente", dataPatient.id);

        const requestFichaClinica = apiform.post(`/api/documentospaciente/`,formData3).then((response) => {
          cache.fichaClinica = { file: fileFichaClinica[0], data: response.data };
          return response;
        })
        requestDocument.push(requestFichaClinica)
      }
    }
    if (!responsable && fileCotizacionExterna != null) {
      if (cache.cotizacion && cache.cotizacion.file === fileCotizacionExterna[0]) {
        requestDocument.push(Promise.resolve({ data: cache.cotizacion.data }))
      } else {
        const formData4 = new FormData();
        formData4.append("archivo", fileCotizacionExterna[0]);
        formData4.append("tipo_documento", "CotizacionExamenExterna");
        formData4.append("nombre_archivo", fileCotizacionExterna[0].name);
        formData4.append("id_paciente", dataPatient.id);

        const requestCotizacion = apiform.post(`/api/documentospaciente/`,formData4).then((response) => {
          cache.cotizacion = { file: fileCotizacionExterna[0], data: response.data };
          return response;
        })
        requestDocument.push(requestCotizacion)
      }
    }
    if (requiereFormularioIsapre && fileFormularioIsapre != null) {
      if (cache.formularioIsapre && cache.formularioIsapre.file === fileFormularioIsapre[0]) {
        requestDocument.push(Promise.resolve({ data: cache.formularioIsapre.data }))
      } else {
        const formData5 = new FormData();
        formData5.append("archivo", fileFormularioIsapre[0]);
        formData5.append("tipo_documento", "FormularioSolicitudExtraIsapre");
        formData5.append("nombre_archivo", fileFormularioIsapre[0].name);
        formData5.append("id_paciente", dataPatient.id);

        const requestFormularioIsapre = apiform.post(`/api/documentospaciente/`,formData5).then((response) => {
          cache.formularioIsapre = { file: fileFormularioIsapre[0], data: response.data };
          return response;
        })
        requestDocument.push(requestFormularioIsapre)
      }
    }
    if(requestDocument.length > 0){
      Promise.all(requestDocument).then((request) => {
        const listTempResponseFile = request.map((response) => response.data)
        setresponseFile(listTempResponseFile)
      }).catch(() => {
        handleSnakeMessage("No se pudieron subir los documentos adjuntos. Revise su conexión e intente nuevamente.", "error");
        setsending(false);
      })
    } else {
      setresponseFile([])
    }

  }

  const sendExam = () => {
    let tempListaInsumos = [];
    dataMedicalArray.map((row) => {
      tempListaInsumos.push({
        cantidad: row.cantidad,
        id_insumo_medicamento: row.id,
      });
    });
    dataResourceArray.map((row) => {
      tempListaInsumos.push({
        cantidad: row.cantidad,
        id_insumo_medicamento: row.id,
      });
    });
    let sendPost = {
      indicaciones: indications,
      justificaciones: justifications,
      realiza_cmh: responsable,
      fecha_hora_examen: moment(examDate).format("YYYY-MM-DDTHH:mm:ss"),
      prioridad: priority,
      lista_examen_clinica: selectedListExam.map((row) => row.value),
      lista_insumos: tempListaInsumos,
    };


    responseFile.map((file) => {
      if(file.tipo_documento === "OrdenExamenes"){
        sendPost["id_orden_examen"] = file.id
     
      } else if(file.tipo_documento === "AutorizacionExamenesIsapre"){
        sendPost["id_autorizacion_isapre"] = file.id
      } else if(file.tipo_documento === "FichaClinica"){
        sendPost["id_ficha_clinica"] = file.id
      } else if(file.tipo_documento === "CotizacionExamenExterna"){
        sendPost["id_cotizacion_examen_externo"] = file.id
      } else if(file.tipo_documento === "FormularioSolicitudExtraIsapre"){
        sendPost["id_formulario_solicitud_extra_isapre"] = file.id
      }
    })

    api.post(`/api/paciente/${dataPatient.id}/solicitudes/examenes/`, sendPost).then((response) => {
        handleSnakeMessage("Solicitud de exámenes generada con éxito", "success");
        getListRequestPatient(dataPatient, dispatch)
        setOpenDialogSendRequest(true);
        setresponseFile(null)
        setsending(false);
      }).catch(() => {
        handleSnakeMessage("No se pudo generar la solicitud. Revise su conexión e intente nuevamente.", "error");
        setresponseFile(null)
        setsending(false);
      })
  };


  const valuesSelected = selectedListExam.map((row) => row.value)
  const auxExamList = examsList.filter(exam => !valuesSelected.includes(exam.value));

  const _content_ =  <div>
    <Grid item container xs={12} justify="center">
      <SelectExam
        examSelected={examSelected}
        handleExamSelected={handleExamSelected}
        examsList={auxExamList}
      />
    </Grid>
    <Grid item container xs={12} justify="center">
        {selectedListExam.map(examSelected => {
            return (
              <Chip
                key={examSelected.value}
                className='mr-2 mb-2'
                label={examSelected.label}
                onDelete={() => handleExamDeleted(examSelected.value)}
                variant="outlined"
                color='primary'
              />
            )
          })}
    </Grid>
    {tempExam != "" ? (
        <Grid item container xs={12} justify="center">
        {pageRefresh && <div></div>}
        <Grid item container xs={12} justify="center" alignItems="center">
          <Grid item xs={1} />
          <Grid item container xs={10} justify="center" alignItems="center">
            <Grid
              item
              container
              xs={12}
              justify="center"
              alignItems="center"
              //spacing={1}
            >
              <Grid item container xs={4} justify="center">
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend">
                    ¿Quién realiza el análisis?
                  </FormLabel>
                  <RadioGroup
                    aria-label="gender"
                    name="gender1"
                    value={responsable}
                    onChange={handleResponsable}
                  >
                    <FormControlLabel
                      value={true}
                      control={<Radio color="primary" />}
                      label="CMH"
                    />
                    <FormControlLabel
                      value={false}
                      control={<Radio color="primary" />}
                      label="Laboratorio Externo"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item container xs={4} justify="center" alignItems="center">
                <MuiPickersUtilsProvider locale="es" utils={MomentUtils}>
                  <Grid container justify="center">
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="DD-MM-YYYY"
                      margin="normal"
                      id="date-picker-inline1"
                      label="Fecha del examen"
                      value={examDate}
                      onChange={handleExamDate}
                      minDate={moment()}
                      minDateMessage={"La fecha del examen no puede ser anterior al día de hoy"}
                      cancelLabel={"Cancelar"}
                      okLabel={"Aceptar"}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
                <MuiPickersUtilsProvider locale="es" utils={MomentUtils}>
                  <Grid container justify="center">
                    <KeyboardTimePicker
                      margin="normal"
                      id="time-picker"
                      label="Hora del examen"
                      value={examDate}
                      onChange={handleExamDate}
                      KeyboardButtonProps={{
                        "aria-label": "change time",
                      }}
                      cancelLabel={"Cancelar"}
                      okLabel={"Aceptar"}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item container xs={4} justify="center">
                <Grid item container xs={12} justify="center">
                  <Grid
                    item
                    container
                    xs={12}
                    justify="center"
                    style={{ marginBottom: "4px" }}
                  >
                    <span>
                      {fileRequestExam === null ? "" : fileRequestExam[0]?.name}{"Orden obligatoria"}
  
                    </span>
                  </Grid>
                  <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ textTransform: "none", marginRight: "3px" }}
                  >
                    Adjuntar orden de examen
                    <TextField
                      type="file"
                      id="exam"
                      onChange={(event) => {
                        uploadedDocsRef.current.order = null;
                        setFilesRequestExam(event.target.files);
                      }}
                      fullWidth
                      my={2}
                      style={{ display: "none" }}
                      accept={("pdf", "jpg", "jpeg", "png")}
                    />
                  </Button>
                </Grid>
                <Grid item container xs={12} justify="center">
                  <Grid
                    item
                    container
                    xs={12}
                    justify="center"
                    style={{ marginBottom: "4px" }}
                  >
                    <span>
                      {fileIsapreAuthorization
                        ? fileIsapreAuthorization[0]?.name
                        : ""}
  
                    </span>
                  </Grid>
                  {!clinic &&
                    <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ textTransform: "none", marginRight: "3px" }}
                  >
                    Adjuntar autorización de isapre
                    <TextField
                      type="file"
                      id="exam"
                      onChange={(event) => {
                        uploadedDocsRef.current.isapre = null;
                        setFileIsapreAuthorization(event.target.files);
                      }}
                      fullWidth
                      my={2}
                      style={{ display: "none" }}
                      accept={("pdf", "jpg", "jpeg", "png")}
                    />
                  </Button>
                  }

                </Grid>
                <Grid item container xs={12} justify="center">
                  <Grid
                    item
                    container
                    xs={12}
                    justify="center"
                    style={{ marginBottom: "4px" }}
                  >
                    <span>
                      {fileFichaClinica === null ? "Ficha clínica obligatoria" : fileFichaClinica[0]?.name}
                    </span>
                  </Grid>
                  <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ textTransform: "none", marginRight: "3px" }}
                  >
                    Adjuntar ficha clínica
                    <TextField
                      type="file"
                      id="ficha-clinica-examen"
                      onChange={(event) => {
                        uploadedDocsRef.current.fichaClinica = null;
                        setFileFichaClinica(event.target.files);
                      }}
                      fullWidth
                      my={2}
                      style={{ display: "none" }}
                      accept={("pdf", "jpg", "jpeg", "png")}
                    />
                  </Button>
                </Grid>
                {requiereFormularioIsapre &&
                <Grid item container xs={12} justify="center">
                  <Grid
                    item
                    container
                    xs={12}
                    justify="center"
                    style={{ marginBottom: "4px" }}
                  >
                    <span>
                      {fileFormularioIsapre === null ? "Formulario de solicitudes extras (Isapre) obligatorio" : fileFormularioIsapre[0]?.name}
                    </span>
                  </Grid>
                  <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ textTransform: "none", marginRight: "3px" }}
                  >
                    Adjuntar formulario de solicitudes extras
                    <TextField
                      type="file"
                      id="formulario-isapre-examen"
                      onChange={(event) => {
                        uploadedDocsRef.current.formularioIsapre = null;
                        setFileFormularioIsapre(event.target.files);
                      }}
                      fullWidth
                      my={2}
                      style={{ display: "none" }}
                      accept={("pdf", "jpg", "jpeg", "png")}
                    />
                  </Button>
                </Grid>
                }
                {!responsable &&
                <Grid item container xs={12} justify="center">
                  <Grid
                    item
                    container
                    xs={12}
                    justify="center"
                    style={{ marginBottom: "4px" }}
                  >
                    <span>
                      {fileCotizacionExterna === null ? "Cotización (opcional, si no se adjunta se genera tarea para el coordinador)" : fileCotizacionExterna[0]?.name}
                    </span>
                  </Grid>
                  <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    style={{ textTransform: "none", marginRight: "3px" }}
                  >
                    Adjuntar cotización empresa externa
                    <TextField
                      type="file"
                      id="cotizacion-examen-externo"
                      onChange={(event) => {
                        uploadedDocsRef.current.cotizacion = null;
                        setFileCotizacionExterna(event.target.files);
                      }}
                      fullWidth
                      my={2}
                      style={{ display: "none" }}
                      accept={("pdf", "jpg", "jpeg", "png")}
                    />
                  </Button>
                </Grid>
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1} />
        </Grid>

        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "2em" }}
        >
          <Grid item xs={1} />
          <Grid item container xs={10} justify="center">
            <Grid item container xs={12} justify="center" spacing={1}>
              <Grid item container xs={6} justify="center">
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Prioridad
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={priority}
                    onChange={handlePriority}
                    label="Prioridad"
                  >
                    <MenuItem value={"Baja"}>Baja</MenuItem>
                    <MenuItem value={"Media"}>Media</MenuItem>
                    <MenuItem value={"Alta"}>Alta</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            
          </Grid>
          <Grid item xs={1} />
        </Grid>
  
        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "2em" }}
        >
          <Grid item xs={1} />
          <Grid item container xs={10} justify="center">
            <Grid item container xs={12} justify="center">
              <TextField
                fullWidth
                multiline
                rows={4}
                id="outlined-basic2"
                label="Indicaciones"
                variant="outlined"
                value={indications}
                onChange={(e) => setIndications(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={1} />
        </Grid>

        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "2em" }}
        >
          <Grid item xs={1} />
          <Grid item container xs={10} justify="center">
            <TextField
              fullWidth
              multiline
              rows={4}
              id="outlined-basic-justificaciones"
              label="Justificaciones"
              variant="outlined"
              value={justifications}
              onChange={(e) => setJustifications(e.target.value)}
            />
          </Grid>
          <Grid item xs={1} />
        </Grid>

        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "2em" }}
        >
          <Grid item container xs={1} />
          <Grid item container xs={10} justify="center">
            <MedicalTableComponent
              dataMedicalArray={dataMedicalArray}
              setDataMedicalArray={setDataMedicalArray}
              medicalResourceData={medicalResourceData}
              //listMedical={listMedical}
              listMedical={listMedical.filter((list) =>
                dataMedicalArray.every((data) => data.id !== list.value)
              )}
              setPageRefresh={setPageRefresh}
            />
          </Grid>
          <Grid item container xs={1} />
        </Grid>
  
        <Grid
          item
          container
          xs={12}
          justify="center"
          style={{ marginTop: "2em" }}
        >
          <Grid item xs={1} />
          <Grid item container xs={10} justify="center">
            <ResourceTableComponent
              dataResourceArray={dataResourceArray}
              setDataResourceArray={setDataResourceArray}
              medicalResourceData={medicalResourceData}
              //listResource={listResource}
              listResource={listResource.filter((list) =>
                dataResourceArray.every((data) => data.id !== list.value)
              )}
              setPageRefresh={setPageRefresh}
            />
          </Grid>
          <Grid item xs={1} />
        </Grid>
        {openDialogSendRequest && (
          <DialogSendRequest
            openDialog={openDialogSendRequest}
            closeDialog={() => setOpenDialogSendRequest(false)}
            setTypeRequest={setTypeRequest}
          />
        )}
      </Grid>
    ) : null}
   <UpdateStockButton
      updateStock={updateStock}
    />
</div>

  const _actions_ = <>
      {selectedListExam.length > 0 && fileRequestExam != null && fileFichaClinica != null && justifications.trim() !== "" && (!requiereFormularioIsapre || fileFormularioIsapre != null)?
        <Button
          disabled={sending}
          variant="contained"
          className="text-white"
          style={{
            marginLeft: "1em",
            textTransform: "none",
            backgroundColor: sending ? "#dddddd" : green[500],
          }}
          onClick={() => {uploadDocument()}}
        >
          {sending ? "Enviando..." : "Enviar"}
        </Button> :
        <Button
          disabled
          variant="contained"
          className="text-white"
          style={{
            marginLeft: "1em",
            textTransform: "none",
          }}
       >
         Enviar
       </Button>
      }
      <Button
        variant="contained"
        color="primary"
        style={{
          textTransform: "none",
        }}
        onClick={closeModal}
      >
        Salir
      </Button>
  </>

  return (
    <ModalDialog
        open={openModal}
        onClose={closeModal}
        title={`Ingresar datos de los examenes a crear`}
        _content_={_content_}
        _actions_ = {_actions_}
    />
  );
};

export default ModalRequestExam;

